import * as Sentry from '@sentry/react'
import store from 'main/store'
import { fetcher } from 'services/helpers/responseHandler'
import { sessionExpiredHandler } from 'services/helpers/sessionExpiredHandler'
import LocalUserService from 'services/localUserService'

/** Fail-safe: avoid re-entrancy when handling UnAuthorized (e.g. log post returns 401) */
let isHandlingUnauthorized = false

export function checkIfSessionExists() {
  const isSessionTimedOut = store.getState().login.sessionTimedOut
  const isSessionExpired = store.getState().login.sessionExpired

  if (isSessionExpired || isSessionTimedOut) {
    console.warn('cancelled request, no session')
  }
}

export function handleUnsuccesfulResponse(data, url) {
  if (data?.isSuccess) {
    return
  }

  if (data?.message?.startsWith('SessionTimedOut')) {
    sessionExpiredHandler()
    console.warn('session expired')
  } else if (data.message?.startsWith('UnAuthorized')) {
    // Avoid recursion: if the failed request was to the logs endpoint, do not post to logs again
    // (otherwise logs 401 would trigger another log post and repeat indefinitely)
    const isLogsEndpoint = url === 'logs' || url.endsWith('/logs')
    // Fail-safe: do not post to logs if we are already handling an UnAuthorized (re-entrancy)
    const mayPostLogs = !isLogsEndpoint && !isHandlingUnauthorized
    if (mayPostLogs) {
      isHandlingUnauthorized = true
      const userService = new LocalUserService()
      const currentUserInfo = userService.getCurrentUserInfo()

      const uiDashboardSessionId = currentUserInfo?.sessionId
      const uiUserName = currentUserInfo?.user?.name
      const uiSubsidiaryName = store.getState().hotelDetails.name
      const uiSubsidiaryId = store.getState().login.currentHotelId
      const uiPath = document.location.pathname

      try {
        fetcher
          .post('logs', {
            level: 'Warn',
            message: `${uiUserName} got UnAuthorized on endpoint ${url}`,
            additionalData: {
              uiDashboardSessionId,
              uiUserName,
              uiSubsidiaryName,
              uiSubsidiaryId,
              uiPath
            }
          })
          .catch(() => {}) // Fail-safe: swallow rejection (e.g. logs endpoint returned 401)
      } catch (error) {
        console.warn('failed to post log', error)
      }
      setTimeout(() => { isHandlingUnauthorized = false }, 0)
    } else {
      setTimeout(() => { isHandlingUnauthorized = false }, 0)
    }

    userNotAuthorizedHandler()
  } else {
    const isExpectedSubsidiaryNotFound =
      data?.message?.includes('Available subsidiary not found!')
    const isExpectedSessionTimeLimitExpired =
      data?.message?.includes('Session cannot be authorized, time limit expired!')
    if (!isExpectedSubsidiaryNotFound && !isExpectedSessionTimeLimitExpired) {
      Sentry.captureMessage(`${data?.message} from ${url}`)
    }
    throw new Error(`${data?.message} from ${url}`)
  }
}

export const userNotAuthorizedHandler = async () =>
  store.dispatch({ type: 'SET_USER_NOT_AUTHORIZED' })

export const userAuthorizedHandler = async () => {
  if (store.getState().login.userNotAuthorized) {
    store.dispatch({ type: 'SET_USER_AUTHORIZED' })
  }
}
